import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'Definí acá los documentos que hay que controlar por equipo: seguro, VTV, habilitaciones, cédula.',
    'Cada documento cargado en un equipo lleva su fecha de vencimiento y el sistema avisa cuando se acerca.',
    'Incluí también la documentación que exige el comitente en obra, no solo la obligatoria.',
  ],
  nextSteps: [
    'Cargar los documentos de cada equipo con su fecha de vencimiento.',
    'Revisar el informe de documentación para anticipar los vencimientos próximos.',
    'Podes cargar mas de un archivo en cada tipo de documentación.',
  ],
};

const ConfiguracionTiposDocumentacion = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="tiposdocumentacion"
      titulo="Tipos de Documentación"
      descripcion="Tipos de documentos del sistema"
      icon="fas fa-file-alt"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionTiposDocumentacion;
